import { useEffect, useRef } from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import Auth from "./layout/Auth";
import Main from "./layout/Main";
import routes from "./routes";
import store from "./store";
import { connect } from "react-redux";

function App() {
  return (
    <div className="font-family-1">
      {/* <Provider store={store}> */}

      <BrowserRouter>
        <Switch>
          {routes.map((route) => {
            switch (route.layout) {
              case "auth":
                return (
                  <Route exact path={route.path}>
                    <Auth>
                      <route.component />
                    </Auth>
                  </Route>
                );
              case "admin":
                return (
                  <Route exact path={route.path}>
                    <Main>
                      <route.component />
                    </Main>
                  </Route>
                );
                {
                  /* default:
                return (
                  <Route exact path={route.path}>
                    <Auth>
                      <route.component />
                    </Auth>
                  </Route>
                ); */
                }
            }
          })}
          <Redirect from="*" to="/" />
        </Switch>
      </BrowserRouter>
      {/* </Provider> */}
    </div>
  );
}
export default App;
